import "../../css/widgets/widgets.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';

function Group(props) {

    const { t } = useTranslation();
    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
        };
    }, []);

    const renderGroupMode = () => {
        let content = <FontAwesomeIcon className="px-1 text-warning" size="lg" icon={duotone("hand")} />
        if (props.group.automatic)
            content = <FontAwesomeIcon className="px-1 text-success" size="lg" icon={duotone("arrows-rotate")} />

        return content;
    };

    return (
        <div className={"d-flex align-items-center me-2 " + (props.group.selected === true ? "bg-light-primary" : "")} style={{ padding: "10px", cursor: "pointer", borderRadius: "10px", margin: "10px" }} onClick={e => props.selectGroup(props.group)}>
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>
                    {t((props.group.opened ? "open" : "closed"))}
                </Tooltip>}>
                <div className="symbol symbol-50px me-3">
                    <div className='user-img text-primary bg-light-primary'>{props.group.initials}</div>
                    <div className={"position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-body h-20px w-20px bg-" + (props.group.opened ? "success" : "danger")}></div>
                </div>
            </OverlayTrigger>

            <div className="w-100">
                <div className="fs-7 text-dark fw-bold w-100">{props.group.groupName} </div>
                <div className="fs-7 text-muted fw-bold">{props.group.campaign || "-"}
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {t((props.group.automatic ? "automatic" : "manual"))}
                        </Tooltip>}>
                        <span className="text-primary float-end">
                            {renderGroupMode()}
                        </span>
                    </OverlayTrigger>

                </div>
            </div>
        </div>
    )
}


export default Group;